import React from "react"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const SM = 735

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W6",
  letterSpacing: "normal",
  color: "#333333",
  fontSize: "34px",
  lineHeight: 1.2,
  textAlign: "center",
  [theme.breakpoints.down(SM)]: {
    whiteSpace: "pre-wrap",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px",
    lineHeight: 1.3,
    maxWidth: "389px",
    margin: "0 auto",
  },
}))

const ContentsTitle = (props) => {
  return (
    <StyledTypography id="contentsTitle">{props.children}</StyledTypography>
  )
}

export default ContentsTitle
